import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function parseSAP(text) {
  const match = text.match(/\[SAP_START\]([\s\S]*?)\[SAP_END\]/);
  if (!match) return null;

  const content = match[1].trim();
  const result = {
    title: '',
    understood: '',
    proposal: '',
    feasibility: { class: 'unknown', notes: '' },
    effect: '',
    preSapText: text.split('[SAP_START]')[0].trim()
  };

  let section = null;
  for (const line of content.split('\n').map(l => l.trim()).filter(Boolean)) {
    if (line.startsWith('TITOLO:'))        { result.title = line.replace('TITOLO:', '').trim(); }
    else if (line.startsWith('HO CAPITO')) { section = 'understood'; result.understood = line.replace(/^HO CAPITO CHE VUOI:?\s*/,'').trim(); }
    else if (line.startsWith('COSA PROP')) { section = 'proposal';   result.proposal = line.replace(/^COSA PROPONGO:?\s*/,'').trim(); }
    else if (line.match(/^FATTIBILIT/))    {
      section = 'feasibility';
      const fText = line.replace(/^FATTIBILIT[AÀ]'?:?\s*/i,'').trim();
      result.feasibility.class = fText.includes('ORA') ? 'now' : fText.includes('TRA ') ? 'later' : fText.includes('NON') ? 'not_possible' : 'unknown';
      result.feasibility.notes = fText;
    }
    else if (line.startsWith('EFFETTO:'))  { section = 'effect'; result.effect = line.replace('EFFETTO:','').trim(); }
    else if (section === 'understood')     { result.understood  += ' ' + line; }
    else if (section === 'proposal')       { result.proposal    += ' ' + line; }
    else if (section === 'feasibility')    { result.feasibility.notes += '\n' + line; }
    else if (section === 'effect')         { result.effect      += ' ' + line; }
  }
  return result;
}

export const SAP_FEASIBILITY = {
  now:          { label: 'Eseguibile ora',        color: 'text-green-700',  bg: 'bg-green-50',  border: 'border-l-green-500' },
  later:        { label: 'Richiede preparazione', color: 'text-amber-700',  bg: 'bg-amber-50',  border: 'border-l-amber-500' },
  not_possible: { label: 'Non fattibile ora',     color: 'text-red-700',    bg: 'bg-red-50',    border: 'border-l-red-400' },
  unknown:      { label: 'Da valutare',           color: 'text-gray-600',   bg: 'bg-gray-50',   border: 'border-l-gray-400' },
};
